import { useEffect } from "react";
import {
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../../stores";
import { BackContainer } from "../../../../types";
import { Column, Row } from "../../../containers";
import { CashActivityData, CashActivityDelete } from "../types";
import { PopupBack, PopupClose } from "../../../../popup";
import { TextInput } from "../../../inputs";
import { Heading } from "../../../typography";
import { addComma } from "../../../../utils";

const CashDeleteActivityPopup = <T extends {}>(
  props: BackContainer<CashActivityData, T>
) => {
  const { data, back } = props;
  const { description, total_price, customer } = data as CashActivityDelete;

  const theme = useThemeStore((s) => s.theme);
  const getCustomerById = useGeneralStore((s) => s.getCustomerById);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 816,
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return (
    <Column style={{ marginBottom: "1rem", position: "relative" }} gap={20}>
      <PopupClose />

      {back ? (
        <PopupBack Component={back.component} props={back.props} />
      ) : (
        <></>
      )}

      <Heading
        textStyles={{ marginTop: "1rem" }}
        size={19}
        color={theme.textOnOverlay}
      >
        حذف نقدی
      </Heading>

      <Row style={{ width: "90%" }} gap={20} className="factor-activity-row">
        {customer ? (
          <TextInput
            label="مشتری"
            value={getCustomerById(customer.$oid)?.fullname || ""}
            inputProps={{ readOnly: true }}
          />
        ) : (
          <></>
        )}

        <TextInput
          label="بابت"
          value={description}
          inputProps={{ readOnly: true }}
        />

        <TextInput
          label="مبلغ"
          value={addComma(total_price)}
          inputProps={{ readOnly: true }}
        />
      </Row>
    </Column>
  );
};

export default CashDeleteActivityPopup;
